import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled, { withTheme } from "styled-components";
import { ToastOptions } from "../ToastManager/constants";
import { ToastSettings } from "./constants";

const StyledToastHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.4rem 0.75rem;
  color: #6c757d;
  background-color: ${(props) => ToastSettings[props.type].color};
  background-clip: padding-box;
`;

const StyledToastTitle = styled.strong`
  background-color: ${(props) => ToastSettings[props.type].color};
  color: ${(props) => ToastSettings[props.type].icon};
  padding-left: 4px;
`;

const StyledToastCardInfo = styled.span`
  text-align: center;
  margin-right: auto;
  font-size: 0.9em;
`;

const StyledToastSymbol = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 5px;
  background-color: ${(props) => ToastSettings[props.type].icon};
`;

const StyledToastBody = styled.div`
  padding: 0.75rem;
  background-color: ${(props) => ToastSettings[props.type].color};
  font-size: 1.1em;
  text-align: left;
`;

const StyledToastCounter = styled.small`
  font-weight: bolder;
  padding-right: 4px;
`;

const StyledToastHeaderColStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-right: auto;
`;

const StyledToastHeaderColEnd = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

const ToastUGNX = (props) => {
  const {
    type,
    cardName,
    toastProps,
    title,
    isRtl,
    countDown = ToastOptions.countDown,
  } = props;

  const [counter, setCounter] = useState(countDown);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const getToastHeader = () => {
    if (isRtl) {
      return (
        <StyledToastHeader {...{ type }}>
          <StyledToastHeaderColEnd>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => toast.dismiss(toastProps?.toastId)}
            />
            {toastProps.autoClose !== false && (
              <StyledToastCounter>{counter || ""}</StyledToastCounter>
            )}
          </StyledToastHeaderColEnd>
          {cardName && (
            <StyledToastHeaderColStart>
              <StyledToastCardInfo>{cardName}</StyledToastCardInfo>
            </StyledToastHeaderColStart>
          )}
          <StyledToastHeaderColStart>
            <StyledToastTitle {...{ type }}>{title}</StyledToastTitle>
            <StyledToastSymbol {...{ type }} />
          </StyledToastHeaderColStart>
        </StyledToastHeader>
      );
    }

    return (
      <StyledToastHeader {...{ type }}>
        <StyledToastHeaderColStart>
          <StyledToastSymbol {...{ type }} />
          <StyledToastTitle {...{ type }}>{title}</StyledToastTitle>
        </StyledToastHeaderColStart>
        {cardName && (
          <StyledToastHeaderColStart>
            <StyledToastCardInfo>{cardName}</StyledToastCardInfo>
          </StyledToastHeaderColStart>
        )}
        <StyledToastHeaderColEnd>
          {toastProps.autoClose !== false && (
            <StyledToastCounter>{counter || ""}</StyledToastCounter>
          )}
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => toast.dismiss(toastProps?.toastId)}
          />
        </StyledToastHeaderColEnd>
      </StyledToastHeader>
    );
  };

  return (
    <>
      {getToastHeader()}
      <StyledToastBody {...{ type }}>{props.children}</StyledToastBody>
    </>
  );
};

export default withTheme(ToastUGNX);
